import React from 'react';
import classNames from 'classnames';
import { ThreeDotIcon } from '../icons/three-dot-icon';
import { ACTIONS_MENU, ACTIONS_MENU_BTN } from '../../../common/constants/data-hooks';
import ActionsMenuItemsDesktop from './actions-menu-items-desktop';
import { VerticallyPositionedContainer } from '../vertically-positioned-container/vertically-positioned-container';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import DropdownButton from '../dropdown-button/dropdown-button';
import styles from './actions-menu-desktop.scss';
const ActionsMenuDesktop = (props) => {
    const isEmpty = !props.share && !props.edit && !props.delete && !props.report;
    const t = useTranslate();
    if (isEmpty && !props.showDummy) {
        return null;
    }
    return (React.createElement(DropdownButton, { className: styles.container, buttonProps: {
            'data-hook': ACTIONS_MENU_BTN,
            className: classNames('wc-icon-fill', styles.moreButton),
            'aria-label': t('more-button.more-actions'),
            children: React.createElement(ThreeDotIcon, null),
        }, disabled: isEmpty, onShowCallback: () => props.onShowMenu?.() }, ({ isKbTriggered }) => (React.createElement(VerticallyPositionedContainer, { dataHook: ACTIONS_MENU, className: styles.actionsContainer, offset: 36 },
        React.createElement(ActionsMenuItemsDesktop, { ...props, shouldAutofocus: isKbTriggered })))));
};
export default ActionsMenuDesktop;
//# sourceMappingURL=actions-menu-desktop.js.map